const { PanelBody, PanelRow, Button, TextControl, SelectControl } = wp.components;
import { useState } from "react";
const { __ } = wp.i18n;
import BMediaUpload from "../../BMediaUpload";
import PremiumText from "../../PremiumText";
import { produce } from "immer";

import { InlineMediaUpload, ItemsPanel } from "../../../../../../bpl-tools/Components";

const Quality = ({ attributes, setAttributes, isPremium }) => {
  const { quality } = attributes;

  const [activeIndex, setActiveIndex] = useState(0);

  const setValue = (value) => {
    const property = Object.keys(value)?.[0];
    setAttributes({ quality: value[property] });
  };

  return (
    <PanelBody className="bPlPanelBody" title={__("Qualities", "h5vp")} initialOpen={false}>
      <PremiumText isPremium={isPremium} />
      <ItemsPanel
        {...{ attributes: { quality }, setAttributes: setValue, activeIndex, setActiveIndex }}
        arrKey="quality"
        itemLabel="Quality"
        ItemSettings={QualityItem}
        design="sortable"
        newItem={{
          video_file: "",
          size: "720",
        }}
      />
    </PanelBody>
  );
};

export default Quality;

export const QualityItem = ({ attributes, arrKey, index, setAttributes, setActiveIndex }) => {
  const item = attributes[arrKey][index];

  const updateQuality = (property, val, childProperty = null) => {
    const newItems = produce(attributes[arrKey], (draft) => {
      if (null !== childProperty) {
        draft[index][property][childProperty] = val;
      } else {
        draft[index][property] = val;
      }
    });

    setAttributes({ [arrKey]: newItems });
    setActiveIndex && setActiveIndex(index);
  };

  return (
    <>
      <SelectControl
        label={__("Size", "h5vp")}
        options={[
          { label: "720p", value: "720" },
          { label: "1080p", value: 1080 },
        ]}
        value={item.size}
        onChange={(size) => updateQuality("size", size)}
      />
      <InlineMediaUpload label="Source" onChange={(video_file) => updateQuality("video_file", video_file)} value={item?.video_file} placeholder="Video Source" />
    </>
  );
};
